const localizeForm = (
  formObject,
  {
    CLASS_FORM_CLASSNAME_LABEL,
    CLASS_FORM_CLASSNAME_PLACEHOLDER,
    CLASS_FORM_CLASSNAME_ERROR,
    CLASS_FORM_CLASSLEVEL_LABEL,
    CLASS_FORM_CLASSLEVEL_PLACEHOLDER,
    CLASS_FORM_CLASSLEVEL_ERROR,
    CLASS_FORM_ORGANIZATION_LABEL,
    CLASS_FORM_ORGANIZATION_PLACEHOLDER,
    CLASS_FORM_ORGANIZATION_ERROR,
    CLASS_FORM_SUBORGANIZATION_LABEL,
    CLASS_FORM_SUBORGANIZATION_PLACEHOLDER,
    CLASS_FORM_SUBORGANIZATION_ERROR,
  }
) => {
  const updatedForm = {
    ...formObject,
    formField: {
      ...formObject.formField,
      className: {
        ...formObject.formField.className,
        label: CLASS_FORM_CLASSNAME_LABEL ?? formObject.formField.className.label,
        placeholder: CLASS_FORM_CLASSNAME_PLACEHOLDER ?? formObject.formField.className.placeholder,
        errorMsg: CLASS_FORM_CLASSNAME_ERROR ?? formObject.formField.className.errorMsg,
      },
      classLevel: {
        ...formObject.formField.classLevel,
        label: CLASS_FORM_CLASSLEVEL_LABEL ?? formObject.formField.classLevel.label,
        placeholder:
          CLASS_FORM_CLASSLEVEL_PLACEHOLDER ?? formObject.formField.classLevel.placeholder,
        errorMsg: CLASS_FORM_CLASSLEVEL_ERROR ?? formObject.formField.classLevel.errorMsg,
      },
      organization: {
        ...formObject.formField.organization,
        label: CLASS_FORM_ORGANIZATION_LABEL ?? formObject.formField.organization.label,
        placeholder:
          CLASS_FORM_ORGANIZATION_PLACEHOLDER ?? formObject.formField.organization.placeholder,
        errorMsg: CLASS_FORM_ORGANIZATION_ERROR ?? formObject.formField.organization.errorMsg,
      },
      subOrganization: {
        ...formObject.formField.subOrganization,
        label: CLASS_FORM_SUBORGANIZATION_LABEL ?? formObject.formField.subOrganization.label,
        placeholder:
          CLASS_FORM_SUBORGANIZATION_PLACEHOLDER ??
          formObject.formField.subOrganization.placeholder,
        errorMsg: CLASS_FORM_SUBORGANIZATION_ERROR ?? formObject.formField.subOrganization.errorMsg,
      },
    },
  };
  return updatedForm;
};

export default localizeForm;
